import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FeatureToggleService, GroupContextService, hd, TicketService } from '@nx-fe/services';
import { Ticket } from '../../ticket.model';
@Component({
  selector: 'ssp-ticket-card',
  templateUrl: './ticket-card.component.html',
  styleUrls: ['./ticket-card.component.scss'],
})
export class TicketCardComponent implements OnInit {
  @ViewChild('tooltipElement') tooltipElement: ElementRef;
  /** The ticket data bound to the component */
  @Input()
  public ticket: Ticket;

  @Input()
  public isSelected: boolean;

  public ticketStatus: hd.IDropdownList | hd.IDropdownListItem;

  public groupName: string;

  constructor(
    private ticketService: TicketService,
    private groupContextService: GroupContextService,
    private featureToggleService: FeatureToggleService,
    private cdef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.ticketStatus = this.ticketService.getTicketStatus(this.ticket.status);

    if (this.featureToggleService.isEnabled('Groups') && this.ticket.groupName) {
      //this.groupContextService.getGroupName(this.ticket.groupId);
      this.groupName = this.ticket.groupName;
    }
    this.cdef.detectChanges();  // avoid Angular error NG0100
  }
}
